module.exports = __webpack_public_path__ + "img/ic_add_new.e6c88786.svg";